import api from '@pray/shared/utils/api';

export type ExperimentCategoryId =
  | 'paywalls'
  | 'tabs'
  | 'onboarding'
  | 'triggers'
  | 'pricing'
  | 'daily'
  | 'web'
  | 'other';

export type ExperimentCategory = {
  id: ExperimentCategoryId;
  name: string;
  description: string;
  instancePatterns: string[];
  instanceCount: number;
  experimentCount: number;
  activeCount: number;
  inactiveCount: number;
  archivedCount: number;
  instances: string[];
};

export type GetExperimentCategoriesResponse = {
  data: {
    categories: ExperimentCategory[];
    totalStats: {
      total: number;
      active: number;
      inactive: number;
      archived: number;
    };
  };
};

export type GetExperimentCategoriesParams = {
  includeArchived?: boolean;
};

/**
 * Returns all experiment categories with counts and metadata
 * @param includeArchived - Whether to include archived experiments in the counts
 */
export async function getExperimentCategories({ includeArchived = false }: GetExperimentCategoriesParams = {}) {
  const params: Record<string, string | boolean> = {};

  if (includeArchived) params.include_archived = true;

  const url = '/web/studio/experiments/categories';

  const response = await api.executeGetRequest<GetExperimentCategoriesResponse>(url, params);

  return response.data;
}
